module.exports = __webpack_public_path__ + "static/media/login-image.be9fa468.jpg";